import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { SatelliteTaskListStore } from "../../store/SatelliteTaskListStore";

type SatelliteTaskListDialogsProps = {
  store: SatelliteTaskListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de SatelliteTask.
 * Separado para mantener SatelliteTaskListPage más limpio.
 */
export const SatelliteTaskListDialogs: React.FC<SatelliteTaskListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
